import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ArrowLeft } from "lucide-react";

// Pulsante "Torna indietro" intelligente: usa la history del browser quando la provenienza è YouPAM
// (same-origin), altrimenti fallback deterministico (es. profilo struttura → tab corretto).
export function SmartBack({ fallbackTo, label }) {
  const nav = useNavigate();
  const { t } = useTranslation();
  const onBack = () => {
    // React Router mantiene history.state.idx: 0 = prima entry (tab nuova/deep-link) → fallback;
    // > 0 = esiste navigazione interna YouPAM → nav(-1) preserva query/filtri/scroll (gestiti dal browser).
    const idx = window.history.state?.idx ?? 0;
    if (idx > 0) nav(-1);
    else nav(fallbackTo);
  };
  return (
    <button onClick={onBack} data-testid="smart-back-btn"
      className="inline-flex items-center gap-1.5 text-sm font-medium text-slate-600 hover:text-blue-600 mb-4">
      <ArrowLeft className="w-4 h-4" /> {label || t("common.back")}
    </button>);
}
